
import { Toggle } from '05-ui-kit';
import { computed, useSlots } from '@vue/composition-api';
import { formatPrice } from '@artmizu/utils';
import type { Review } from '~/type/Review';
import TSProductRating from '~/components/ts-components/TSProductRating/TSProductRating.vue';
import { useAuthStore } from '~/store/modal/auth';
import { useUserStore } from '~/store/user';
const __sfc_main = {};
__sfc_main.props = {
  data: {
    key: "data",
    required: true,
    type: null
  },
  showProductInfo: {
    key: "showProductInfo",
    required: false,
    type: Boolean,
    default: false
  },
  activeField: {
    key: "activeField",
    required: false,
    type: Boolean,
    default: false
  },
  isHideAvatar: {
    key: "isHideAvatar",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const slots = useSlots();
  const {
    enable: enableAuthModal
  } = useAuthStore();
  const userState = useUserStore();
  const userAuth = computed(() => userState.userAuth);
  function onAnswer(cb: () => Promise<void>) {
    if (userAuth.value) {
      cb();
    } else {
      enableAuthModal({
        onComplete: () => cb()
      });
    }
  }
  return {
    formatPrice,
    emit,
    slots,
    onAnswer
  };
};
__sfc_main.components = Object.assign({
  TSProductRating,
  Toggle
}, __sfc_main.components);
export default __sfc_main;
